import { SET_NOTIFICATION, CLOSE_NOTIFICATION } from './types'

export const setNotification = (payload) => ({
  type: SET_NOTIFICATION,
  payload,
})

export const closeNotification = () => ({
  type: CLOSE_NOTIFICATION,
})
